import { ConsumptionPlaceModel } from './consumptionPlace.model';
import { WorkerModel } from './worker.model';

export enum ReadingUnitType {
  GAS = 'GAS',
  ELECTRICITY = 'ELECTRICITY',
}

export interface BaseReadingUnitModel {
  plannedReadingDate: string;
  currentClosingDate: string;
  bundle: string;
}

export interface ReadingUnitModel extends BaseReadingUnitModel {
  id: number;
  readingUnitCode: string;
  readingCenter: string;
  readingReason: string;
  sapBatchExecutionId: number;
  consumptionPlaces?: ConsumptionPlaceModel[];
  workerId: number;
  worker: WorkerModel;
}
